export enum CountryAbbreviationEnum {
  USA = 'USA',
  MEXICO = 'MEX',
  CANADA = 'CAN'
}
